export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/crm/crm.jpg'),
        title: 'ProphetCRM',
        description: '帮助中国客户走向海外',
        component: ''
      }
  ],
  step1:{
    title: '助力中小企业数字化转型，利用数据更好的挖掘客户，服务客户，留住客户',
    description: `ProphetCRM帮助中国客户走向海外，同时帮助海外客户进入中国市场`,
    cases: [
      { title: '大量海外项目经验', imgUrl: require('../../../assets/images/services/crm/case1.png') },
      { title: '海外客户资源', imgUrl: require('../../../assets/images/services/crm/case2.png') },
      { title: '海外市场推广', imgUrl: require('../../../assets/images/services/crm/case3.png') }
    ]
  },
  step2: {
    title: 'ProphetCRM如何帮助您?',
    description: '',
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/1.png'),
        title: '透明沟通',
        description: `ProphetCRM嵌入微软的Outlook中 -自动跟踪和记录您团队的活动。
        `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/2.png'),
        title: '高效的环境',
        description: `ProphetCRM定制的自动化销售确保客户收到快速，有意义的反馈。
        `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/3.png'),
        title: '使用便捷',
        description: `类似于Excel的操作可以帮助您的团队将ProphetCRM无缝地运用到日常工作进程中
        `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/4.png'),
        title: '强大的分析',
        description: `将预测和活动追踪融合进报告中，让管理者做出正确并关键的决定
        `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/5.png'),
        title: '个性化的文件',
        description: `直接从ProphetCRM生成的报价，文档和表单，使您的团队能够在一个系统中进行操作。
        `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/6.png'),
        title: '地域不受限制',
        description: `ProphetCRM适用于IOS系统和Android系统，让办公更有效率
        `
      }
    ]
  },
  step3: {
    title: '为团队设计的CRM',
    imgUrl: require('../../../assets/images/services/crm/placeholder1.jpg'),
    description: `ProphetCRM是为团队而建立。ProphetCRM使销售和项目团队能够团结一致的协作。用户可以直接和核心团队成员合作，或者跟踪跨部门的交付成果进展，确保项目按时完成。ProphetCRM可以允许团队在Outlook环境中继续进行日常工作的部署。`
  },
  step4: {
    title: '我们看重什么？',
    secondTitle: '客户永远是我们的第一要务',
    description: `我们希望和合作伙伴达成长期的合作关系，ProphetCRM系统可以解决公司管理的内部问题，CRM作为一款用于商业合作的客户管理系统，可以帮助客户取得长期的利益`,
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/a.png'),
        title: '实现',
        description: `我们的项目团队致力于了解您的商业模式，以确保ProphetCRM能够准确地反映出您的业务流程。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/b.png'),
        title: '支持',
        description: `我们为我们优秀的员工感到自豪`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/c.png'),
        title: '客户成功',
        description: `在部署之后，客户管理器被分配到您的账户，确保您获得持续的价值`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/d.png'),
        title: '集成',
        description: `我们开放的API允许ProphetCRM所有ERP平台的集成，从而使您的基本系统实现结合`
      }
    ]
  },
  step5: {
    title: '技术细节和兼容性',
    imgUrl: require('../../../assets/images/services/crm/placeholder2.jpg'),
    description: `我们提供云计算和备用的解决方案,以满足您的需要。 此外,ProphetCRM完全兼容微软的Office 365。 我们的手机应用程序是用户友好的,可用在所有主要平台。 我们遵守SOC-2 GDPR规定。<br/>您有从过时的CRM客户信息或在Excel电子表格吗? 我们迁移团队与您工作,确保重要历史数据反映在您的新系统。`
  }
}
